import { useSettings } from "@/context/SettingsContext";
import { Seo } from "@/components/site/Seo";
import { buildWaLink, safeUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MessageCircle, Mail, Phone, Instagram, Facebook } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  return (
    <div className="pt-16">
      <Seo title="Contact Us" description="Reach us on WhatsApp, phone or email to plan your next trek, trip or dham yatra." />
      <div className="bg-secondary text-secondary-foreground">
        <div className="mx-auto max-w-7xl px-6 py-16">
          <p className="uppercase tracking-[0.25em] text-gold text-sm">Say hello</p>
          <h1 className="font-heading text-5xl sm:text-6xl font-semibold mt-2">Contact Us</h1>
          <p className="text-secondary-foreground/70 mt-3 max-w-xl">Questions about a trip or planning a private departure? We're a WhatsApp message away.</p>
        </div>
      </div>
      <div className="mx-auto max-w-3xl px-6 py-16 grid sm:grid-cols-2 gap-6">
        <a href={buildWaLink(settings.whatsapp_number, "Hi Safarshala!")} target="_blank" rel="noreferrer" data-testid="contact-whatsapp"
          className="rounded-2xl border p-8 hover:border-primary hover:-translate-y-1 transition-transform">
          <MessageCircle className="h-8 w-8 text-[#25D366] mb-3" />
          <p className="font-heading text-2xl">WhatsApp</p>
          <p className="text-muted-foreground">{settings.whatsapp_number}</p>
        </a>
        {settings.contact_number && (
          <a href={`tel:${settings.contact_number}`} className="rounded-2xl border p-8 hover:border-primary hover:-translate-y-1 transition-transform">
            <Phone className="h-8 w-8 text-primary mb-3" /><p className="font-heading text-2xl">Call</p><p className="text-muted-foreground">{settings.contact_number}</p>
          </a>
        )}
        {settings.email && (
          <a href={`mailto:${settings.email}`} className="rounded-2xl border p-8 hover:border-primary hover:-translate-y-1 transition-transform">
            <Mail className="h-8 w-8 text-primary mb-3" /><p className="font-heading text-2xl">Email</p><p className="text-muted-foreground break-all">{settings.email}</p>
          </a>
        )}
        <div className="rounded-2xl border p-8">
          <p className="font-heading text-2xl mb-3">Follow Us</p>
          <div className="flex gap-3">
            {safeUrl(settings.instagram) && <a href={safeUrl(settings.instagram)} target="_blank" rel="noreferrer"><Button variant="outline" size="icon" className="rounded-full"><Instagram className="h-5 w-5" /></Button></a>}
            {safeUrl(settings.facebook) && <a href={safeUrl(settings.facebook)} target="_blank" rel="noreferrer"><Button variant="outline" size="icon" className="rounded-full"><Facebook className="h-5 w-5" /></Button></a>}
          </div>
        </div>
      </div>
    </div>
  );
}
